import { createAction } from '../../../core/helpers'

import { FETCH_PRIORITY_TASK, FETCH_PRIORITY_TASKS } from '../action-types'

export const cleanupFetchPriorityTasks = createAction(
  FETCH_PRIORITY_TASKS.CLEANUP,
)

export const cleanupFetchPriorityTask = createAction(
  FETCH_PRIORITY_TASK.CLEANUP,
)
